// extracted by mini-css-extract-plugin
module.exports = {"separatedStatusLabel":"styles_separatedStatusLabel__155s3","statusMargin":"styles_statusMargin__1OPGO","mobile":"styles_mobile__1WnUa"};